export default "__VITE_ASSET__B5yP0oTG__"